var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2705 13.0853L13.1603 10.8177H17.1431V18.8C17.1431 19.0209 16.9513 19.2 16.7146 19.2H7.28599C7.04929 19.2 6.85742 19.0209 6.85742 18.8V11.5955H9.77269L10.4636 10.4492L11.2705 13.0853ZM9.00028 14.4C8.76358 14.4 8.57171 14.5791 8.57171 14.8C8.57171 15.0209 8.76358 15.2 9.00028 15.2H15.0003C15.237 15.2 15.4289 15.0209 15.4289 14.8C15.4289 14.5791 15.237 14.4 15.0003 14.4H9.00028ZM9.00028 16.8C8.76358 16.8 8.57171 16.9791 8.57171 17.2C8.57171 17.4209 8.76358 17.6 9.00028 17.6H11.5717C11.8084 17.6 12.0003 17.4209 12.0003 17.2C12.0003 16.9791 11.8084 16.8 11.5717 16.8H9.00028Z",
    fill: "url(#paint0_linear_696_1019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85742 5.20002C9.85742 4.97911 10.0493 4.80002 10.286 4.80002H13.7146C13.9513 4.80002 14.1431 4.97911 14.1431 5.20002V6.00002C14.1431 6.22093 13.9513 6.40002 13.7146 6.40002H10.286C10.0493 6.40002 9.85742 6.22093 9.85742 6.00002V5.20002Z",
    fill: "url(#paint1_linear_696_1019)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85742 6.4C6.85742 6.17909 7.04929 6 7.28599 6H9.00028C9.00028 6.66276 9.57589 7.2 10.286 7.2H13.7146C14.4247 7.2 15.0003 6.66276 15.0003 6H16.7146C16.9513 6 17.1431 6.17908 17.1431 6.4V10.0177H12.741L11.6307 11.35L10.7234 8.38616L9.27139 10.7954H6.85742V6.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.4C8.7633 14.4 8.57143 14.5791 8.57143 14.8C8.57143 15.0209 8.7633 15.2 9 15.2H15C15.2367 15.2 15.4286 15.0209 15.4286 14.8C15.4286 14.5791 15.2367 14.4 15 14.4H9Z",
    fill: "#4E4E4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.8C8.7633 16.8 8.57143 16.9791 8.57143 17.2C8.57143 17.4209 8.7633 17.6 9 17.6H11.5714C11.8081 17.6 12 17.4209 12 17.2C12 16.9791 11.8081 16.8 11.5714 16.8H9Z",
    fill: "#4E4E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 4C9.57561 4 9 4.53726 9 5.2H7.28571C6.57561 5.2 6 5.73726 6 6.4V18.8C6 19.4628 6.57561 20 7.28571 20H16.7143C17.4244 20 18 19.4628 18 18.8V6.4C18 5.73726 17.4244 5.2 16.7143 5.2H15C15 4.53726 14.4244 4 13.7143 4H10.2857ZM6.85714 6.4C6.85714 6.17909 7.04901 6 7.28571 6H9C9 6.66276 9.57561 7.2 10.2857 7.2H13.7143C14.4244 7.2 15 6.66276 15 6H16.7143C16.951 6 17.1429 6.17908 17.1429 6.4V10.0177H12.7407L11.6304 11.35L10.7232 8.38616L9.27111 10.7954H6.85714V6.4ZM11.2702 13.0853L13.16 10.8177H17.1429V18.8C17.1429 19.0209 16.951 19.2 16.7143 19.2H7.28571C7.04901 19.2 6.85714 19.0209 6.85714 18.8V11.5954H9.77241L10.4633 10.4492L11.2702 13.0853ZM9.85714 5.2C9.85714 4.97909 10.049 4.8 10.2857 4.8H13.7143C13.951 4.8 14.1429 4.97909 14.1429 5.2V6C14.1429 6.22091 13.951 6.4 13.7143 6.4H10.2857C10.049 6.4 9.85714 6.22091 9.85714 6V5.2Z",
    fill: "#4E4E4E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1019",
    x1: 6.73361,
    y1: 11.4589,
    x2: 16.6428,
    y2: 19.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14F27A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_696_1019",
    x1: 6.73361,
    y1: 11.4589,
    x2: 16.6428,
    y2: 19.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14F27A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActiveIcon);
export default __webpack_public_path__ + "static/media/report-active-icon.25536a4e94bbbf99424b8d3edcfff4a6.svg";
export { ForwardRef as ReactComponent };